import objectLength from "../../common-utils/object/objectLength.util.js";
/**
 * Checks whether the provided strictly object has keys or not.
 * @param input object
 * @returns boolean
 */
export const isEmptyStrictObjectUtil = (input) => !objectLength(input);
export default isEmptyStrictObjectUtil;
